<div class="floating-chatbot-container" *ngIf="isVisible">

  <div class="chatbot-backdrop"
    [class.visible]="isOpen && isChatExpanded"
    [attr.aria-hidden]="!(isOpen && isChatExpanded)"
    (click)="expandChat()"></div>

  <!-- The Chat Popup Window -->
  <div class="chatbot-popup" #chatbotPopup [class.open]="isOpen" [class.expanded]="isChatExpanded"
    [class.floating-compact]="isOpen && !isChatExpanded" [class.floating-expanded]="isOpen && isChatExpanded"
    [attr.aria-hidden]="!isOpen">
    <div class="chatbot-header">
      <div class="chatbot-title">
        <span class="neo-chatbot-icon">
          <svg viewBox="0 0 120 120" width="25" height="25">
            <defs>
              <linearGradient id="wh-edge" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stop-color="#6B5FA8" />
                <stop offset="1" stop-color="#E8A0D8" />
              </linearGradient>
              <radialGradient id="wh-nd" cx="50%" cy="50%">
                <stop offset="0" stop-color="#6B5FA8" />
                <stop offset="1" stop-color="#0C1E52" />
              </radialGradient>
              <radialGradient id="wh-nm" cx="50%" cy="50%">
                <stop offset="0" stop-color="#E8A0D8" />
                <stop offset="1" stop-color="#A03090" />
              </radialGradient>
              <radialGradient id="wh-np" cx="50%" cy="50%">
                <stop offset="0" stop-color="#50e070" />
                <stop offset="1" stop-color="#22c55e" />
              </radialGradient>
              <filter id="wh-glow" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur stdDeviation="3" />
              </filter>
            </defs>
            <line x1="28" y1="28" x2="28" y2="92" stroke="url(#wh-edge)" stroke-width="3" opacity="0.55" />
            <line x1="28" y1="28" x2="92" y2="92" stroke="url(#wh-edge)" stroke-width="3" opacity="0.55" />
            <line x1="92" y1="28" x2="92" y2="92" stroke="url(#wh-edge)" stroke-width="3" opacity="0.55" />
            <circle r="4" fill="#E8E2FF" filter="url(#wh-glow)">
              <animate attributeName="cx" values="28;28" dur="3.6s" repeatCount="indefinite" />
              <animate attributeName="cy" values="28;92;92" keyTimes="0;0.33;1" dur="3.6s" repeatCount="indefinite" />
              <animate attributeName="opacity" values="0;1;1;0;0" keyTimes="0;0.05;0.3;0.35;1" dur="3.6s"
                repeatCount="indefinite" />
            </circle>
            <circle r="4" fill="#FFD4F0" filter="url(#wh-glow)">
              <animate attributeName="cx" values="28;28;92;92" keyTimes="0;0.33;0.66;1" dur="3.6s"
                repeatCount="indefinite" />
              <animate attributeName="cy" values="28;28;92;92" keyTimes="0;0.33;0.66;1" dur="3.6s"
                repeatCount="indefinite" />
              <animate attributeName="opacity" values="0;0;1;1;0;0" keyTimes="0;0.33;0.38;0.63;0.68;1" dur="3.6s"
                repeatCount="indefinite" />
            </circle>
            <circle r="4" fill="#22c55e" filter="url(#wh-glow)">
              <animate attributeName="cx" values="92;92" dur="3.6s" repeatCount="indefinite" />
              <animate attributeName="cy" values="28;28;92;92" keyTimes="0;0.66;1;1" dur="3.6s"
                repeatCount="indefinite" />
              <animate attributeName="opacity" values="0;0;1;1;0" keyTimes="0;0.66;0.71;0.95;1" dur="3.6s"
                repeatCount="indefinite" />
            </circle>
            <circle cx="28" cy="28" r="12" fill="url(#wh-nd)">
              <animate attributeName="r" values="12;15;12" keyTimes="0;0.05;0.2" dur="3.6s" repeatCount="indefinite" />
            </circle>
            <circle cx="28" cy="92" r="11" fill="url(#wh-np)">
              <animate attributeName="r" values="11;11;15;11;11" keyTimes="0;0.3;0.35;0.5;1" dur="3.6s"
                repeatCount="indefinite" />
            </circle>
            <circle cx="92" cy="28" r="11" fill="url(#wh-nm)">
              <animate attributeName="r" values="11;11;15;11;11" keyTimes="0;0.63;0.68;0.83;1" dur="3.6s"
                repeatCount="indefinite" />
            </circle>
            <circle cx="92" cy="92" r="11" fill="url(#wh-nm)">
              <animate attributeName="r" values="11;11;15;11" keyTimes="0;0.96;1;1" dur="3.6s"
                repeatCount="indefinite" />
            </circle>
          </svg>
        </span>
        <div class="chatbot-title-text">
          <span class="chatbot-title-main">Welcome to Neo.ai</span>
          <span class="chatbot-title-sub">Your Data Analyst</span>
        </div>
      </div>

      <span class="chatbot-header-actions">
        <button matTooltip="New chat" matTooltipPosition="above" class="header-action-btn new-chat-btn" type="button" aria-label="New chat" (click)="callNewChat()">
          <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.75 12.375V5.875M7.5 9.125H14M5.33333 17.25V19.7801C5.33333 20.3574 5.33333 20.646 5.45166 20.7942C5.55457 20.9232 5.71063 20.9982 5.87558 20.998C6.06526 20.9978 6.29064 20.8175 6.7414 20.4569L9.32565 18.3895C9.85356 17.9672 10.1175 17.756 10.4114 17.6058C10.6722 17.4726 10.9498 17.3752 11.2366 17.3164C11.56 17.25 11.898 17.25 12.5741 17.25H15.3C17.1202 17.25 18.0303 17.25 18.7255 16.8958C19.337 16.5842 19.8342 16.087 20.1458 15.4755C20.5 14.7803 20.5 13.8702 20.5 12.05V6.2C20.5 4.37983 20.5 3.46974 20.1458 2.77453C19.8342 2.163 19.337 1.66582 18.7255 1.35423C18.0303 1 17.1202 1 15.3 1H6.2C4.37983 1 3.46974 1 2.77453 1.35423C2.163 1.66582 1.66582 2.163 1.35423 2.77453C1 3.46974 1 4.37983 1 6.2V12.9167C1 13.9241 1 14.4279 1.11074 14.8412C1.41126 15.9627 2.28729 16.8387 3.40884 17.1393C3.82213 17.25 4.32586 17.25 5.33333 17.25Z"
              stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>

        <button [matTooltip]="isChatExpanded ? 'Collapse chat' : 'Expand chat'" matTooltipPosition="above" class="header-action-btn expand-btn" type="button"
          [attr.aria-label]="isChatExpanded ? 'Collapse chat' : 'Expand chat'" (click)="expandChat()">
          <svg *ngIf="!isChatExpanded" width="18" height="18" viewBox="0 0 22 22" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M12.9167 8.58333L20.5 1M20.5 7.5V1H14M8.58333 12.9167L1 20.5M1 14L1 20.5H7.5" stroke="white"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <!-- <svg *ngIf="isChatExpanded" width="18" height="18" viewBox="0 0 22 22" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M9.08333 13.4167L1.5 21M1.5 14.5V21H8M13.4167 9.08333L21 1.5M14.5 1.5H21V8" stroke="white"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg> -->

          <svg *ngIf="isChatExpanded" width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.58333 19.4167V12.9167H2.08333M8.58333 12.9167L1 20.5M12.9167 2.08333V8.58333H19.4167M12.9167 8.58333L20.5 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <button matTooltip="Close chat" matTooltipPosition="above" class="header-action-btn close-btn" type="button" aria-label="Close chat" (click)="toggleChat()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </span>
    </div>
    <div class="chatbot-body"
      [class.is-chat-transition-out]="chatTransitionState === 'out'"
      [class.is-chat-transition-in]="chatTransitionState === 'in'">
      <app-scraii-ai [isFloatingView]="true" [isFloatingExpanded]="isChatExpanded" [brandKey]="activeBrandKey" [pageName]="pageName" *ngIf="isVisible"></app-scraii-ai>
    </div>
  </div>

  <!-- The FAB Button -->
  <button class="chatbot-fab" (click)="toggleChat()" [class.active]="isOpen" [class.hidden]="isChatExpanded && isOpen">
    <svg *ngIf="!isOpen" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V11.2C1 12.8802 1 13.7202 1.32698 14.362C1.6146 14.9265 2.07354 15.3854 2.63803 15.673C3.27976 16 4.11984 16 5.8 16H12.3163C12.9403 16 13.2523 16 13.5508 16.0613C13.8156 16.1156 14.0718 16.2055 14.3125 16.3285C14.5838 16.4671 14.8275 16.662 15.3148 17.0518L17.7002 18.9602C18.1163 19.2931 18.3244 19.4595 18.4995 19.4597C18.6517 19.4599 18.7958 19.3906 18.8908 19.2716C19 19.1348 19 18.8684 19 18.3355V5.8Z"
        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg *ngIf="isOpen" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </button>

</div>
